import { motion } from "framer-motion";
import { Check } from "lucide-react";

const monthlyIncludes = [
  "2 sessions per month",
  "60 min per session",
  "Home practice cards",
  "WhatsApp parent updates",
];

export default function Fees() {
  return (
    <section
      id="fees"
      className="py-24 md:py-40 relative overflow-hidden"
      style={{ background: "var(--ink)", color: "#fff" }}
      data-testid="fees-section"
    >
      {/* Floating color discs */}
      <div className="absolute top-16 -left-24 w-[420px] h-[420px] rounded-full opacity-40 pointer-events-none"
        style={{ background: "radial-gradient(circle, var(--brand), transparent 60%)" }} aria-hidden />
      <div className="absolute -bottom-24 right-0 w-[520px] h-[520px] rounded-full opacity-30 pointer-events-none"
        style={{ background: "radial-gradient(circle, var(--violet), transparent 60%)" }} aria-hidden />

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-8">
            <span className="font-mono-editorial text-[11px] text-white/60">Fee Structure</span>
            <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tight">
              Simple.
              <br />
              <span className="italic font-serif-editorial" style={{ color: "var(--sunflower)" }}>Transparent.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 self-end text-white/70 leading-relaxed">
            Quarterly commitment required to enroll. No hidden fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-stretch">
          {/* Monthly */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="md:col-span-5 border border-white/25 p-8 md:p-10 flex flex-col"
            data-testid="fees-monthly"
          >
            <span className="font-mono-editorial text-[10px] tracking-[0.32em] text-white/60">Monthly rate</span>
            <div className="mt-6 flex items-baseline gap-2">
              <span className="font-display text-8xl md:text-9xl leading-none tracking-tighter">$60</span>
              <span className="font-serif-editorial italic text-lg text-white/70 leading-tight">
                / child<br />/ month
              </span>
            </div>
            <ul className="mt-8 space-y-3">
              {monthlyIncludes.map((m) => (
                <li key={m} className="flex items-center gap-3 text-white/85">
                  <Check size={16} color="var(--mint)" strokeWidth={2} />
                  <span>{m}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Quarterly — featured */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.08 }}
            className="md:col-span-7 relative border-2 p-8 md:p-12 flex flex-col overflow-hidden"
            style={{ background: "var(--brand)", borderColor: "var(--sunflower)", color: "#fff" }}
            data-testid="fees-quarterly"
          >
            <div className="absolute top-6 right-6 px-4 py-1.5 rounded-full text-[10px] font-mono-editorial tracking-[0.28em]" style={{ background: "var(--sunflower)", color: "var(--ink)" }}>
              REQUIRED TO ENROLL
            </div>
            <span className="font-mono-editorial text-[10px] tracking-[0.32em] text-white/85">Quarterly commitment</span>
            <div className="mt-6 flex items-baseline gap-3">
              <span className="font-display text-8xl md:text-[9rem] leading-none tracking-tighter">$180</span>
              <span className="font-serif-editorial italic text-lg text-white/85 leading-tight">
                / child<br />/ 3 months
              </span>
            </div>
            <div className="mt-6 font-mono-editorial text-[11px] tracking-[0.18em] text-white/80">
              $60 × 3 months · billed quarterly
            </div>
            <div className="mt-8 border-t border-white/25 pt-6 flex items-center justify-between">
              <span className="font-serif-editorial italic text-2xl">One-time registration</span>
              <span className="font-display text-5xl tracking-tighter" style={{ color: "var(--sunflower)" }}>$25</span>
            </div>
            <div className="mt-4 text-white/80 text-sm">Per child · payable at enrollment.</div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
